import React from "react";

import { Grid } from "@mui/material";
import { AppListItem } from "Components/AppListItem";
import { MemberStaff } from "Models/members/member.staff";
import { useTranslation } from "react-i18next";

import { MemberDetailsContainer, MemberDetailsWrapper, SectionTitle } from "./styles";

interface MemberUserDetailsProps {
  currentMember: MemberStaff;
}
export const MemberStaffDetails = ({ currentMember }: MemberUserDetailsProps) => {
  const { t: translate } = useTranslation();

  return (
    <>
      <div>
        <SectionTitle>{translate("staffInformation")}</SectionTitle>
      </div>
      <MemberDetailsContainer>
        <MemberDetailsWrapper>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <AppListItem
                title={translate("emergencyName")}
                subtitle={currentMember.emergencyName}
                verifyIfIsEmpty
                disableGutters
              />
            </Grid>
            <Grid item xs={4}>
              <AppListItem
                title={translate("emergencyPhone")}
                subtitle={currentMember.emergencyPhone}
                verifyIfIsEmpty
                disableGutters
              />
            </Grid>
            <Grid item xs={4}>
              <AppListItem
                title={translate("emergencyEmail")}
                subtitle={currentMember.emergencyEmail}
                verifyIfIsEmpty
                disableGutters
              />
            </Grid>
            <Grid item xs={4}>
              <AppListItem
                title={translate("emergencyRelationship")}
                subtitle={currentMember.emergencyRelationship}
                verifyIfIsEmpty
                disableGutters
              />
            </Grid>
            <Grid item xs={4}>
              <AppListItem
                title={translate("residencyStatus")}
                subtitle={currentMember.residencyStatus}
                verifyIfIsEmpty
                disableGutters
              />
            </Grid>
          </Grid>
        </MemberDetailsWrapper>
      </MemberDetailsContainer>
    </>
  );
};
